/**
 * Quali FONTI ha la scheda tornei che si sta guardando — e in particolare quando la gamba
 * QDuels ha diritto di parola.
 *
 * 🔴 ESISTE PER UNA REGRESSIONE DI PRODUZIONE trovata in revisione il 2026-09-06, prima del
 * rilascio, e vale la pena raccontarla per intero perche' e' **lo stesso guasto della PR che
 * la conteneva, col segno invertito**.
 *
 * La correzione agli stati onesti introduce `reachable: false` per dire «questa fonte e'
 * spenta da configurazione: non l'ho interrogata». Giusto — su `stg-tma`, dove COMMUNITY e
 * LIVE hanno **solo** la gamba QDuels e senza di lei non sanno niente.
 *
 * Ma `VITE_FEATURE_QDUELS_TOURNAMENTS_ENABLED` e' opt-in e `.env.production` non lo dichiara:
 * **in produzione `qduelsOn` e' SEMPRE falso**. Passando la gamba QDuels comunque, le viste
 * `tournaments` (il pannello Hub «Eventi», spinto incondizionatamente) e `sitAndGo`
 * finivano in `unavailable` — «Non disponibile su questo backend» — anche con Laravel che
 * risponde `200` con un elenco. Cioe' **un'affermazione falsa sulla superficie viva in
 * produzione**, prodotta dalla difesa contro le affermazioni false.
 *
 * ⇒ La distinzione che serviva e' fra due cose che «gamba spenta» confondeva ancora:
 *  · in una vista **FUSA** (Laravel + QDuels) Laravel da solo e' una **risposta completa**:
 *    QDuels spento li' e' NON PERTINENTE, e una fonte non pertinente non si passa affatto;
 *  · in una vista **SOLO-QDuels** non c'e' nessun altro a rispondere: li' spenta significa
 *    davvero «non posso chiedere», e va detto.
 *
 * 📌 *Il perimetro di una difesa va misurato dove NON serve, non solo dove serve.* Su
 * staging la riga era giusta in tutte e quattro le viste; in produzione era giusta in due.
 */

/**
 * Le viste che non hanno una gamba Laravel: qui QDuels e' l'unica fonte.
 *
 * ⛔ Tenerlo come dato, non come `||` sparso: e' la stessa lista che decide `undefined` in
 * `activeLaravelQuery`, e due copie divergono.
 */
export const QDUELS_ONLY_VIEWS: ReadonlySet<string> = new Set(['community', 'live']);

/**
 * Se la gamba QDuels va passata a `listVerdict` per questa vista.
 *
 * @param view      la scheda attiva
 * @param hasQuery  esiste una query QDuels per questa vista (altrimenti non e' pertinente)
 * @param qduelsOn  il flag di build (in AND col gioco Clash Royale) e' acceso
 */
export function qduelsLegIsPertinent(view: string, hasQuery: boolean, qduelsOn: boolean): boolean {
  if (!hasQuery) return false;
  // Accesa: parla sempre, fusa o no.
  if (qduelsOn) return true;
  // Spenta: ha ancora voce SOLO dove e' l'unica fonte — altrove tacere e' la verita', perche'
  // Laravel ha risposto per intero.
  return QDUELS_ONLY_VIEWS.has(view);
}
